import { invokeApi } from "../bl_libs/invokeApi";
import { getAccessToken } from "../utils/authStorage";

export const get_home_dashboard_api = async (data = {}) => {
  const requestObj = {
    path: `api/partner/home_dashboard`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${getAccessToken()}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
